import React from 'react'
import SideBar from '../SideBar/SideBar'

import Logo from '../../Supertools/Logo'
import Search from './Search'


// #343131

export default function Header( {show}) {
  return (
    <div>

 
        <header  style={{background:'#0a0a0a' , height: '60px' , top:0 , position:'sticky'}}>

            <div className='row pt-2'>
                <div className='col-2'>

                    <SideBar></SideBar>

                </div>

                <div className='col-4 ' style={{color:'white'}}>
                    <Logo></Logo> 
                    {/* <img height={40} src='https://img1.wsimg.com/isteam/ip/dc190deb-86b3-4414-a186-9cc686df12c8/thumbnail_logo-super-tools%20(1).png' alt=''></img> */}
                </div>

                <div className='col-3'>

                  

                </div>


                <div className='col-3'>
                    <img height={40} src='https://snapon.com.mx/wp-content/uploads/2020/12/logo-snap-on-2x-1.png' alt=''></img>
                </div>

            </div>

        

        </header>
        <Search show={show}/>

    </div>
  )
}
